import {
  EventEmitter
} from "events";

class ClientInteropabilityService extends EventEmitter {
  loadFormFactor(store) {
    store.commit("UPDATE_FORM_FACTOR", navigator.userAgent);
  }

  focussedProjectChange(store, project) {
    store.dispatch("updateFocussedProject", project);
  }
}

export default new ClientInteropabilityService();
